import { rebrandForEveryone } from "../../common/publicCompany";

export const TERMS_OF_SERVICE_URL = "https://artlogic.net/legal/terms-and-conditions-of-service";
export const PRIVACY_POLICY_URL = "https://artlogic.net/legal/privacy";

export function termsOfServiceUrl(): string {
    return rebrandForEveryone() ? TERMS_OF_SERVICE_URL : "https://artcloud.com/terms";
}

export function privacyPolicyUrl(): string {
    return rebrandForEveryone() ? PRIVACY_POLICY_URL : "https://artcloud.com/privacy";
}
